import React, { useState } from "react";
import cx from "classnames";
import { connect } from "react-redux";
import CheckCircleOutlineSharpIcon from "@material-ui/icons/CheckCircleOutlineSharp";
import CloseSharpIcon from "@material-ui/icons/CloseSharp";
import MinimizeSharpIcon from "@material-ui/icons/MinimizeSharp";
import LaunchSharpIcon from "@material-ui/icons/LaunchSharp";
import { setDownloaderVisibility } from "../../../store/loader/actions";
import DownloadAnim from "../download-anim";
import "./index.less";
import { DOWNLOAD_STATUS } from "../../../constants/constants";

/** return Download status icon */
function getDownloadStatusIcon(status = "") {
	switch (status) {
		case DOWNLOAD_STATUS.completed:
			return <CheckCircleOutlineSharpIcon />;
		case DOWNLOAD_STATUS.failed:
			return <CloseSharpIcon style={{ color: "red" }} />;
		case DOWNLOAD_STATUS.downloading:
			return <DownloadAnim />;
		case DOWNLOAD_STATUS.uploading:
			return <DownloadAnim type={"uploading"} />;
		default:
			return <DownloadAnim />;
	}
}

/** Return download status text */
function getDownloadStatusText(status = "") {
	switch (status) {
		case DOWNLOAD_STATUS.completed:
			return "- Downloaded";
		case DOWNLOAD_STATUS.failed:
			return "- Failed";
		case DOWNLOAD_STATUS.downloading:
			return "- In Progress";
		case DOWNLOAD_STATUS.uploading:
			return "- Uploading";
		default:
			return "- In Progress";
	}
}

/** Return download progress */
function DownloadProgress({
	downloadingFiles,
	showDownloadProgress,
	setDownloaderVisibility
}) {
	const [isMinimize, setIsMinimize] = useState(false);
	return (
		<>
			{downloadingFiles.length && showDownloadProgress ? (
				<div className={cx("download-progress", isMinimize && "minimizeBlock")}>
					<div className={"row download-header"}>
						<div className={"col-xs-10"}>
							<span>{"File Downloader"}</span>
						</div>
						<div className={"col-xs-1 end-xs"}>
							{!isMinimize ? (
								<span
									onClick={() => setIsMinimize(!isMinimize)}
									className={"minimizeIcon"}
								>
									<MinimizeSharpIcon />
								</span>
							) : (
								<span onClick={() => setIsMinimize(!isMinimize)}>
									<LaunchSharpIcon style={{ fontSize: "1.3em" }} />
								</span>
							)}
						</div>
						<div className={"col-xs-1 end-xs"}>
							<span onClick={() => setDownloaderVisibility(false)}>
								<CloseSharpIcon style={{ fontSize: "1.3em" }} />
							</span>
						</div>
					</div>
					{!isMinimize ? (
						<div className={"download-queue"}>
							{downloadingFiles.map(({ dKey, fileName, status }) => (
								<div className={"row dInfo"} key={dKey}>
									<div className={"col-xs-10"}>
										<span>{`${fileName} ${getDownloadStatusText(status)}`}</span>
									</div>
									<div className={"col-xs-2 center-xs"}>
										{getDownloadStatusIcon(status)}
									</div>
								</div>
							))}
						</div>
					) : (
						""
					)}
				</div>
			) : (
				""
			)}
		</>
	);
}

/** Map state to for above functions props */
const mapStateToProps = state => {
	const {
		loaderConfig: { downloadingFiles, showDownloadProgress }
	} = state;
	return {
		downloadingFiles: downloadingFiles.slice(0, 4),
		showDownloadProgress
	};
};

const mapDispatchToProps = dispatch => {
	return {
		setDownloaderVisibility: param => dispatch(setDownloaderVisibility(param))
	};
};

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DownloadProgress);
